import React from 'react'
import Helmet from 'components/Helmet'
import Banner from 'components/Banner'
//import Content, { Col, Row } from 'components/Content'
import Link from 'components/Link';
import HomeFeatWorkWrapper from '../components/HomeFeatWorkWrapper';
import IntroHeader from '../components/IntroHeader';
import HomeSlider from '../components/HomeSlider';
export default function Home({ data }) {
 
  
  return (
    <main className="maincontent">
      <Helmet
        title='Studio Gritt // Interiors / Architecture / Products'
        description='Studio gritt is a multi-disciplinary design studio. A dynamic group of young creatives strongly driven by design.' 
      />

      <IntroHeader />


      <section className="cs-section cs-home home-recent--projects">

        <div className="cs-home-about--text">
          <div className="container">
            <h5 >Our design horizon is boundless and encompasses <Link to='/architecture' className="homeText-Link-wrapper"><span className="homeText-Link-container"></span>Architecture</Link>, <Link to='/interiors' className="homeText-Link-wrapper"><span className="homeText-Link-container"></span>Interiors</Link> and <Link to='/products' className="homeText-Link-wrapper"><span className="homeText-Link-container"></span>Products</Link>.</h5>
          </div>
        </div>

        <HomeSlider posts={data.allWordpressPost.edges.slice(0,3)} />
          {/* <div className="container">
            <HomeFeatWorkWrapper />
          </div>
    */}
      </section>
      
    </main>
  )
}

export const query = graphql`
  query HomePageQuery {
    bannerImage: imageSharp(id: { regex: "/banners/martin-jernberg-297304.jpg/" }) {
      sizes(
        quality: 80
        maxWidth: 1920
      ) {
        ...GatsbyImageSharpSizes
      }
    }

    allWordpressPost( filter : { categories : { name : { eq:"Featured" } } }) {
      edges {
        node {
          id
          slug
          title
          excerpt
          slug
          featured_media {
            id
            source_url
          }
          categories {
            id
            name
          }
        }
      }
    }


  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js